import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Site, UserInfo, SuportSearchResult } from 'app/models/support.model';
import { environment } from '../../../environments/environment';
import dictionary from "dict/static.json";
import { DataProvider2 } from "../../provider/data2.provider";
export var PromopultBalanceActionTypes = {
    INCREASE: 'increase',
    DECREASE: 'decrease',
};
var SupportService = /** @class */ (function () {
    function SupportService(dpParent) {
        this.dpParent = dpParent;
        this.i18nTariffs = {
            'premium': {
                name: 'тариф «Минимальный»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: true
            },
            'premium-2022': {
                name: 'тариф «Минимальный»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: true
            },
            'premiumplus': {
                name: 'тариф «Базовый»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: false
            },
            'premiumplus-2022': {
                name: 'тариф «Базовый»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: false
            },
            'pro': {
                name: 'тариф «Про»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: false
            },
            'pro-2022': {
                name: 'тариф «Про»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: false
            },
            'shop': {
                name: 'тариф «Магазин»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: true
            },
            'shop-2022': {
                name: 'тариф «Магазин»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: true
            },
            'promo': {
                name: 'тариф «Промо»',
                variants: {
                    'lifetime': 'Пожизненно',
                },
                customDateTo: false,
                proOrder: false
            },
            'municipal': {
                name: 'тариф «Муниципальный»',
                variants: {
                    'lifetime': 'Пожизненно',
                },
                customDateTo: false,
                proOrder: false
            },
            'newyear2018': {
                name: 'тариф «Новогодний»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: false
            },
            'sberbank-premium': {
                name: '[Sberbank WL] тариф «Минимальный»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: false,
                proOrder: false
            },
            'sberbank-premiumplus': {
                name: '[Sberbank WL] тариф «Базовый»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: false,
            },
            'sberbank-pro': {
                name: '[Sberbank WL] тариф «Про»',
                variants: {
                    'month': '1 Месяц',
                    '3months': '3 Месяца',
                    '6months': '6 Месяцев',
                    '12months': 'Год',
                    '24months': '2 года',
                },
                customDateTo: true,
                proOrder: false
            },
        };
        this.cluster = dictionary.config.projectId;
        this.dictionary = dictionary;
    }
    Object.defineProperty(SupportService.prototype, "dp", {
        get: function () {
            var me = this;
            return {
                get: function (endpoint, queryParams) {
                    queryParams = queryParams || {};
                    queryParams['cluster'] = me.cluster;
                    return me.dpParent.get(endpoint, queryParams);
                },
                post: function (endpoint, queryParams) {
                    endpoint = endpoint + "?cluster=" + me.cluster;
                    return me.dpParent.post(endpoint, queryParams);
                },
                put: function (endpoint, queryParams) {
                    endpoint = endpoint + "?cluster=" + me.cluster;
                    return me.dpParent.put(endpoint, queryParams);
                },
                delete: function (endpoint, queryParams) {
                    endpoint = endpoint + "?cluster=" + me.cluster;
                    return me.dpParent.delete(endpoint, queryParams);
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    ;
    SupportService.prototype.getSearchResult = function (value, typeFilter, accurateSiteSearch) {
        return this.dp.get('/support/negotiator/search', {
            value: encodeURIComponent(value),
            typeFilter: typeFilter, accurateSiteSearch: accurateSiteSearch
        });
    };
    SupportService.prototype.getUserInfoByID = function (id) {
        return this.dp.get("/support/negotiator2/users/0000" + id);
    };
    SupportService.prototype.getSiteByID = function (id) {
        return this.dp.get("/support/negotiator2/sites/" + id).pipe(map(function (data) {
            console.log('data', data);
            // Проверяем, что data не равен null или undefined
            if (!data) {
                return data; // возвращаем как есть (null или undefined)
            }
            // Проверяем существование data['pages'] и что это массив
            if (data['pages'] && Array.isArray(data['pages'])) {
                data['pageCount'] = data['pages'].filter(function (p) { return !p.match(/^_/); }).length;
            }
            else {
                data['pageCount'] = 0;
            }
            return data;
        }));
    };
    SupportService.prototype.getLogs = function (userId, siteUrl) {
        return this.dp.get('/log', { userId: userId, siteUrl: siteUrl })
            .pipe(map(function (r) { return r['stats']; }));
    };
    SupportService.prototype.saveNote = function (userId, note) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/saveNote", {
            userId: userId,
            note: note,
            comment: '--------------'
        });
    };
    SupportService.prototype.getSiteLogs = function (siteId) {
        return this.dp.get('/log', { siteId: siteId })
            .pipe(map(function (d) { return d['stats']; }));
    };
    SupportService.prototype.getSptuDetail = function (userId) {
        return this.dp.get("/support/negotiator/users/0000" + userId + "/sptuDetail");
    };
    SupportService.prototype.setSptuDetail = function (userId, premiumTemplates, comment) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/sptu", { userId: userId, comment: comment, premiumTemplates: premiumTemplates });
    };
    SupportService.prototype.getSiblings = function (userId) {
        return this.dp.get("/support/negotiator/users/" + userId + "/getSiblings");
    };
    SupportService.prototype.setMultilangParentId = function (siteId, multilangParentId, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/setMultilangParentId", { siteId: siteId, multilangParentId: multilangParentId, comment: comment });
    };
    SupportService.prototype.unsetMultilangParentId = function (siteId, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/unsetMultilangParentId", { siteId: siteId, comment: comment });
    };
    SupportService.prototype.setPro = function (userId, pro, comment) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/spu", { userId: userId, pro: pro, comment: comment });
    };
    SupportService.prototype.changeCurrency = function (userId, currency, comment) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/currency", { userId: userId, currency: currency, comment: comment });
    };
    SupportService.prototype.restorePassword = function (userId, comment) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/restoreUserPassword", { userId: userId, comment: comment });
    };
    SupportService.prototype.restoreSite = function (siteId, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/siteRestore", { siteId: siteId, comment: comment });
    };
    SupportService.prototype.cloneSite = function (userId, siteId, domain, email, comment) {
        return this.dp.post("/support/negotiator/users/0000" + userId + "/sites/" + siteId + "/clone", { url: domain, email: email, comment: comment });
    };
    SupportService.prototype.setPassword = function (userId, password, comment) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/sup", { userId: userId, password: password, comment: comment });
    };
    SupportService.prototype.setBan = function (userId, message, comment) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/userBan", { userId: userId, message: message, comment: comment });
    };
    SupportService.prototype.setUnBan = function (userId, comment) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/userUnBan", { userId: userId, comment: comment });
    };
    SupportService.prototype.setRole = function (userId, role, admin, accessor, comment) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/setUserRole", { userId: userId, role: role, admin: admin, accessor: accessor, comment: comment });
    };
    SupportService.prototype.setFreemiumUser = function (userId, mode, comment) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/setFreemiumUser", { userId: userId, mode: mode, comment: comment });
    };
    SupportService.prototype.setFreemiumSite = function (siteId, mode, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/setFreemium", { siteId: siteId, mode: mode, comment: comment });
    };
    SupportService.prototype.renewTrial = function (siteId, addDays, rtfsFilter, dateTrialStart, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/rtfs", {
            siteId: siteId,
            addDays: addDays,
            rtfsFilter: rtfsFilter,
            dateTrialStart: dateTrialStart,
            comment: comment
        });
    };
    SupportService.prototype.setSiteBlock = function (siteId, message, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/siteBlock", { siteId: siteId, message: message, comment: comment });
    };
    SupportService.prototype.setSiteUnBlock = function (siteId, message, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/siteUnBlock", { siteId: siteId, message: message, comment: comment });
    };
    // deprecated
    SupportService.prototype.setSiteBan = function (siteId, message, comment) {
        return this.dp.post("/support/negotiator/sites/" + siteId + "/siteBan", { siteId: siteId, message: message, comment: comment });
    };
    SupportService.prototype.banSitesByList = function (siteList, message, comment) {
        return this.dp.put("/support/negotiator/banAllSites", { siteList: siteList, message: message, comment: comment });
    };
    SupportService.prototype.checkForDivly = function (sitesList) {
        return this.dp.get('/support/negotiator/checkSitesForDivly', { sitesList: sitesList });
    };
    SupportService.prototype.setDivlyId = function (userId, partnerId, comment) {
        return this.dp.put("/support/negotiator/users/0000" + userId + "/setDivlyId", { userId: userId, partnerId: partnerId, comment: comment });
    };
    SupportService.prototype.setDivlyLabel = function (siteId, action, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/" + action + "DivlyLabel", { siteId: siteId, comment: comment });
    };
    SupportService.prototype.setSEODivlyLabel = function (siteId, action, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/" + action + "SEODivlyLabel", { siteId: siteId, comment: comment });
    };
    SupportService.prototype.breakPublish = function (siteId, comment) {
        return this.dp.post("/support/negotiator/sites/" + siteId + "/breakPublish", { siteId: siteId, comment: comment });
    };
    SupportService.prototype.changeLang = function (siteId, userId, newLang, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/changeLang", { siteId: siteId, userId: userId, newLang: newLang, comment: comment });
    };
    SupportService.prototype.fixWidgets = function (siteId, action, comment) {
        if (comment === void 0) { comment = ''; }
        return this.dp.put("/support/negotiator/sites/" + siteId + "/fixWidgets", { siteId: siteId, action: action, comment: comment });
    };
    // deprecated
    SupportService.prototype.uberTariff = function (siteId, uberStartDate, userId, time, comment) {
        return this.dp.post("/support/negotiator/sites/" + siteId + "/uber_tariff", {
            siteId: siteId,
            uberStartDate: uberStartDate,
            userId: userId,
            page: 1,
            time: time,
            comment: comment
        });
    };
    SupportService.prototype.getTariffs = function (siteId) {
        var _this = this;
        if (environment.SEXTANT) {
            var me_1 = this;
            return new Observable(function (observer) {
                var tariffs = [
                    {
                        '_idToRender': null,
                        '_idEqualsTo': null,
                        'extendsProcessing': [],
                        'variants': [
                            {
                                'name': 'month',
                                'amount': {
                                    'USD': 500,
                                    'RUB': 30000,
                                    'BRL': 1999,
                                    'PLN': 1950,
                                    'NGN': 158000
                                },
                                'duration': 1,
                                'weight': 0,
                                'predefinedDiscount': 0,
                                'showMinimalAmount': true
                            },
                            {
                                'name': '3months',
                                'amount': {
                                    'USD': 1425,
                                    'RUB': 85500,
                                    'BRL': 5899,
                                    'PLN': 5558,
                                    'NGN': 450300
                                },
                                'duration': 3,
                                'weight': 10,
                                'predefinedDiscount': 5,
                                'showMinimalAmount': true
                            },
                            {
                                'name': '6months',
                                'amount': {
                                    'USD': 2700,
                                    'RUB': 162000,
                                    'BRL': 9999,
                                    'PLN': 10530,
                                    'NGN': 853200
                                },
                                'duration': 6,
                                'weight': 20,
                                'predefinedDiscount': 10,
                                'showMinimalAmount': true
                            },
                            {
                                'name': '12months',
                                'amount': {
                                    'USD': 4800,
                                    'RUB': 288000,
                                    'BRL': 18999,
                                    'PLN': 18720,
                                    'NGN': 1516800
                                },
                                'duration': 12,
                                'weight': 30,
                                'predefinedDiscount': 20,
                                'showMinimalAmount': true
                            },
                            {
                                'name': '24months',
                                'amount': {
                                    'USD': 8400,
                                    'RUB': 504000,
                                    'BRL': 27380,
                                    'PLN': 32760,
                                    'NGN': 2654400
                                },
                                'duration': 24,
                                'weight': 40,
                                'predefinedDiscount': 30,
                                'showMinimalAmount': true
                            }
                        ],
                        'isCommon': true,
                        'showDateTo': true,
                        'rebill': true,
                        'upgradeAbility': true,
                        'upgradeDateTo': false,
                        'isMain': false,
                        'weight': 1,
                        'predefinedDiscount': 0,
                        '_id': 'premium',
                        'features': {
                            'domainConnect': true
                        },
                        'amountBase': {
                            'USD': 500,
                            'RUB': 30000,
                            'BRL': 1999,
                            'PLN': 1950,
                            'NGN': 158000
                        },
                        '__v': 0
                    },
                    {
                        '_idToRender': null,
                        '_idEqualsTo': null,
                        'extendsProcessing': [],
                        'variants': [
                            {
                                'name': 'month',
                                'amount': {
                                    'USD': 1000,
                                    'RUB': 60000,
                                    'BRL': 3260,
                                    'PLN': 3900,
                                    'NGN': 316000
                                },
                                'duration': 1,
                                'weight': 0,
                                'predefinedDiscount': 0,
                                'showMinimalAmount': true
                            },
                            {
                                'name': '3months',
                                'amount': {
                                    'USD': 2850,
                                    'RUB': 171000,
                                    'BRL': 9290,
                                    'PLN': 11115,
                                    'NGN': 900600
                                },
                                'duration': 3,
                                'weight': 10,
                                'predefinedDiscount': 5,
                                'showMinimalAmount': true
                            },
                            {
                                'name': '6months',
                                'amount': {
                                    'USD': 5400,
                                    'RUB': 324000,
                                    'BRL': 17600,
                                    'PLN': 21060,
                                    'NGN': 1706400
                                },
                                'duration': 6,
                                'weight': 20,
                                'predefinedDiscount': 10,
                                'showMinimalAmount': true
                            },
                            {
                                'name': '12months',
                                'amount': {
                                    'USD': 9600,
                                    'RUB': 576000,
                                    'BRL': 31200,
                                    'PLN': 37440,
                                    'NGN': 3033600
                                },
                                'duration': 12,
                                'weight': 30,
                                'predefinedDiscount': 20,
                                'showMinimalAmount': true
                            },
                            {
                                'name': '24months',
                                'amount': {
                                    'USD': 16800,
                                    'RUB': 1008000,
                                    'BRL': 54800,
                                    'PLN': 65520,
                                    'NGN': 5308800
                                },
                                'duration': 24,
                                'weight': 40,
                                'predefinedDiscount': 30,
                                'showMinimalAmount': true
                            }
                        ],
                        'isCommon': true,
                        'showDateTo': true,
                        'rebill': true,
                        'upgradeAbility': true,
                        'upgradeDateTo': false,
                        'isMain': true,
                        'weight': 2,
                        'predefinedDiscount': 0,
                        '_id': 'premiumplus',
                        'features': {
                            'domainConnect': true,
                            'premiumTemplates': true,
                            'goals': true,
                            'supportChat': true
                        },
                        'amountBase': {
                            'USD': 1000,
                            'RUB': 60000,
                            'BRL': 3260,
                            'PLN': 3900,
                            'NGN': 316000
                        },
                        '__v': 0
                    }
                ];
                var i18nTariffs = me_1.i18nTariffs;
                tariffs = tariffs.filter(function (tariff) {
                    return tariff._id in i18nTariffs;
                });
                tariffs = tariffs.reduce(function (arr, tariff) {
                    if (tariff._id === 'premium') {
                        arr.unshift(tariff);
                    }
                    else {
                        arr.push(tariff);
                    }
                    return arr;
                }, []);
                observer.next(tariffs);
                observer.complete();
            });
        }
        return this.dp.get("/support/negotiator/sites/" + siteId + "/attsDetail")
            .pipe(map(function (data) {
            var tariffs = data['tariffs'];
            var i18nTariffs = _this.i18nTariffs;
            tariffs = tariffs.filter(function (tariff) { return tariff._id in i18nTariffs; });
            tariffs = tariffs.reduce(function (arr, tariff) {
                if (tariff._id === 'premium') {
                    arr.unshift(tariff);
                }
                else {
                    arr.push(tariff);
                }
                return arr;
            }, []);
            return tariffs;
        }));
    };
    SupportService.prototype.attachTariff = function (siteId, tariffId, variantName, customDateTo, customDaysCount, periodType, transactionId, amount, paymentType, paymentId, notFirstPayment, comment) {
        var body = {
            siteId: siteId,
            tariffId: tariffId,
            variantName: variantName,
            periodType: periodType,
            transactionId: transactionId,
            amount: amount,
            paymentType: paymentType,
            paymentId: paymentId,
            notFirstPayment: notFirstPayment,
            comment: comment
        };
        if (periodType === 1) {
            body['customDateTo'] = '';
            body['customDaysCount'] = '';
        }
        else if (periodType === 2) {
            body['customDateTo'] = customDateTo;
            body['customDaysCount'] = '';
        }
        else if (periodType === 3) {
            body['customDateTo'] = '';
            body['customDaysCount'] = customDaysCount;
        }
        return this.dp.post("/support/negotiator/sites/" + siteId + "/atts", body);
    };
    SupportService.prototype.getChsoDetail = function (siteId) {
        return this.dp.get("/support/negotiator/sites/" + siteId + "/chsoDetail");
    };
    SupportService.prototype.changeOwner = function (siteId, oldOwnerEmail, newOwnerEmail, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/chso", { siteId: siteId, oldOwnerEmail: oldOwnerEmail, newOwnerEmail: newOwnerEmail, comment: comment });
    };
    SupportService.prototype.getCtfsDetail = function (siteId, domainUrl) {
        return this.dp.get("/support/negotiator/sites/" + siteId + "/ctfsDetail", { domainUrl: domainUrl });
    };
    SupportService.prototype.changeTariff = function (siteId, tariffId, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/ctfs", { siteId: siteId, tariffId: tariffId, comment: comment });
    };
    SupportService.prototype.renewTariff = function (siteId, dateTo, periodType, customDaysCount, renewRebillDate, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/rifs", { siteId: siteId, dateTo: dateTo, periodType: periodType, customDaysCount: customDaysCount, renewRebillDate: renewRebillDate, comment: comment });
    };
    SupportService.prototype.getMitsDetail = function (siteId, domainUrl) {
        return this.dp.get("/support/negotiator/sites/" + siteId + "/mitsDetail", { domainUrl: domainUrl });
    };
    SupportService.prototype.transferInvoice = function (siteId, userSite, mitsFilter, anotherSite, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/mits", { siteId: siteId, userSite: userSite, mitsFilter: mitsFilter, anotherSite: anotherSite, comment: comment });
    };
    SupportService.prototype.getRsaiDetail = function (siteId, domainUrl) {
        return this.dp.get("/support/negotiator/sites/" + siteId + "/rsaiDetail", { domainUrl: domainUrl });
    };
    SupportService.prototype.removeInvoice = function (siteId, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/rsai", { siteId: siteId, comment: comment });
    };
    SupportService.prototype.disableRecurrentProfile = function (siteId, recurrentProfile, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/disableRecurrentProfile", { siteId: siteId, recurrentProfile: recurrentProfile, comment: comment });
    };
    SupportService.prototype.editRecurrentProfile = function (siteId, rebillStartDate, amount, comment) {
        return this.dp.put("/support/negotiator/sites/" + siteId + "/editRecurrentProfile", { siteId: siteId, rebillStartDate: rebillStartDate, amount: amount, comment: comment });
    };
    SupportService.prototype.getSiteCategories = function () {
        return this.dp.get("/js/admin/static/siteCategories.js");
    };
    SupportService.prototype.checkSupportEdit = function (siteId) {
        return this.dp.get('/accessor/check_support_edit', { siteId: siteId });
    };
    SupportService.prototype.checkAndSaveSupportEdit = function (siteId, category, subject, defer, oldCategory, oldSubject, isSupport) {
        return this.dp.get('/accessor/check_and_save', { siteId: siteId, category: category, subject: subject, defer: defer, oldCategory: oldCategory, oldSubject: oldSubject, isSupport: isSupport });
    };
    SupportService.prototype.getInvoiceInfo = function (siteId, invoiceNumber) {
        return this.dp.get("/support/negotiator/sites/" + siteId + "/checkInvoiceNumber", { invoiceNumber: invoiceNumber });
    };
    SupportService.prototype.searchByEmail = function (email) {
        return this.getSearchResult(email, 'email', true);
    };
    SupportService.prototype.getSupportActionLogs = function (userId, siteUrl) {
        return this.dp.get('/log', { supportId: userId, siteUrl: siteUrl })
            .pipe(map(function (data) { return data['stats']; }));
    };
    SupportService.prototype.getReregList = function (userId) {
        return this.dp.get('/user/rereg', { userId: userId });
    };
    SupportService.prototype.getSiteFiles = function (siteId) {
        return this.dp.get("/support/negotiator2/sites/" + siteId + "/siteFiles");
    };
    SupportService.prototype.deleteSiteFile = function (siteId, folder, fileName, comment) {
        return this.dp.delete("/support/negotiator2/sites/" + siteId + "/siteFile", {
            folder: folder, fileName: fileName, comment: comment,
        });
    };
    SupportService.prototype.refound = function (siteId, data) {
        return this.dp.post("/support/negotiator/sites/" + siteId + "/refound", data);
    };
    Object.defineProperty(SupportService.prototype, "currencyList", {
        get: function () { return this.dictionary.currencyList; },
        enumerable: true,
        configurable: true
    });
    SupportService.prototype.getSiteHistory = function (siteId) {
        return this.dp.get("/site/history/" + siteId);
    };
    SupportService.prototype.setUserHardbounce = function (_a) {
        var userId = _a.userId, hardbounce = _a.hardbounce, comment = _a.comment;
        var endpointUrl = "/support/negotiator/users/0000" + userId + "/hardbounce", data = {
            comment: comment,
        };
        if (hardbounce) {
            return this.dp.put(endpointUrl, data);
        }
        else {
            return this.dp.delete(endpointUrl, data);
        }
    };
    SupportService.prototype.setExcludeFromStats = function (userId, comment) {
        return this.dp.post('/support/negotiator2/exclude', { userId: userId, comment: comment });
    };
    /**
     * Применить оплату к аккаунту в сервисе продвижения Promopult.
     * Может быть больше нуля - пополнение, так и меньше - уменьшение.
     * ВНИМАНИЕ на то, что само API принимает значение в копейках
     * @param siteId
     * @param {string} action Действие по изменению баланса. Можно увеличить или уменьшить
     * @param {number} amount Сумма в рублях
     * @param comment
     */
    SupportService.prototype.updateBalancePromopultBalance = function (siteId, action, amount, comment, supportId) {
        if (amount === 0) {
            throw new Error('updateBalancePromopultBalance: бессмыслено менять баланс промопульта на 0 рублей!');
        }
        var method = '';
        if (action === PromopultBalanceActionTypes.INCREASE) {
            method = 'increaseBalance';
        }
        else if (action === PromopultBalanceActionTypes.DECREASE) {
            method = 'decreaseBalance';
        }
        else {
            throw new Error("updateBalancePromopultBalance: \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0439 \u0442\u0438\u043F \"" + action + "\" \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0431\u0430\u043B\u0430\u043D\u0441\u0430!");
        }
        return this.dp.post("/support/negotiator2/sites/" + siteId + "/promopult/" + method, {
            amount: amount * 100,
            comment: comment,
            supportId: supportId,
        });
    };
    return SupportService;
}());
export { SupportService };
